import * as React from 'react';
import { TApiEquipmentCategory } from '../../types/Equipment';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

interface IEquipmentCategoryDropdownProps {
  category: string;
  handleCategoryChange: (event: SelectChangeEvent<string>) => void;
  categories: Array<TApiEquipmentCategory>;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(3, 0, 1),
      width: '100%',
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    label: {
      backgroundColor: 'white',
      padding: '0 .2rem',
    },
  })
);

const EquipmentCategoryDropdown: React.FC<IEquipmentCategoryDropdownProps> = (
  props
): JSX.Element => {
  const classes = useStyles({});
  const { t, i18n } = useTranslation();

  const getCategoryName = (category: TApiEquipmentCategory): string => {
    return i18n.language === 'en' && category.nameEn ? category.nameEn : category.nameDa;
  };

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel
        id="equipment-category-label"
        shrink
        className={classes.label}
      >
        {t('equipment.category.select.label')}
      </InputLabel>
      <Select
        labelId="equipment-category"
        id="equipment-category"
        displayEmpty
        value={props.category}
        onChange={props.handleCategoryChange}
        label={t('equipment.category.select.label')}
        defaultValue={''}
      >
        <MenuItem value={''} selected>
          <em>{t('equipment.category.select.all')}</em>
        </MenuItem>
        {props.categories.map((category) => {
          return (
            <MenuItem key={category.id} value={category.id}>
              {getCategoryName(category)}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default EquipmentCategoryDropdown;
